module.exports = __webpack_public_path__ + "/659b394541a52876aee837cff7ec3ecc.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/integrations/assets/box.svg
 ** module id = 1599
 ** module chunks = 0
 **/